import { $, $$, on } from '../core/dom.js';

const TABS = ['story', 'guide', 'faq', 'submit'];

/** Faneblade på DMU Generations-siden: Om projektet / Interviewguide / FAQ / Indsend fortælling */
export function initGenTabs(root = document) {
  const tabs = $$('.gen-tab', root);
  if (!tabs.length) return;

  function activate(name) {
    if (!TABS.includes(name)) return;
    tabs.forEach(btn => {
      const active = btn.dataset.genTab === name;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', String(active));
    });
    TABS.forEach(t => {
      const panel = $(`#gen-panel-${t}`, root);
      if (!panel) return;
      const active = t === name;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    root.scrollTop = 0;
  }

  tabs.forEach(btn => on(btn, 'click', () => activate(btn.dataset.genTab)));
  $$('[data-gen-tab-link]', root).forEach(btn =>
    on(btn, 'click', () => activate(btn.dataset.genTabLink))
  );
}
